import { dashboardTableTextActionClassName } from '@shigo-ui/dashboard-ui';
import { Tooltip, TooltipContent, TooltipTrigger } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import { domainComplianceTotal, type DomainComplianceSummary } from '../../model';

export function ComplianceSummary({
  domain,
  interactive,
  visible,
  onOpen,
}: {
  domain: DomainComplianceSummary;
  interactive: boolean;
  visible: boolean;
  onOpen: (domain: DomainComplianceSummary) => void;
}) {
  if (!visible) return '-';
  const value = [
    domain.approvedCnt,
    domain.rejectedCnt,
    domain.notAvailableCnt,
    domainComplianceTotal(domain),
  ].join(' / ');
  const content = (
    <>
      <span className="block">{value}</span>
      <span className="text-muted-foreground block text-xs">
        {dashboardT('supplyDomains.pending', { count: domain.pendingCnt })}
      </span>
    </>
  );

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {interactive ? (
          <button
            type="button"
            className={dashboardTableTextActionClassName()}
            onClick={() => {
              onOpen(domain);
            }}
          >
            {content}
          </button>
        ) : (
          <span className="inline-block">{content}</span>
        )}
      </TooltipTrigger>
      <TooltipContent>{dashboardT('supplyDomains.complianceHint')}</TooltipContent>
    </Tooltip>
  );
}
